import { useOutletContext } from 'react-router-dom'
import type { AgentYamlConfig } from '@/lib/agentYaml'
import type { AgentDetail } from '@/types'

export interface AgentDetailContext {
  projectId: string
  agent: AgentDetail
  canEdit: boolean
  canManageMemory: boolean
  canReadMemory: boolean
  editorYaml: string
  onYamlChange: (yaml: string) => void
  parsedConfig: AgentYamlConfig | null
  unknownYamlKeys: string[]
  displayName: string
  onDisplayNameChange: (value: string) => void
  description: string
  onDescriptionChange: (value: string) => void
  missingRequiredFields: string[]
  isDirty: boolean
  isSaving: boolean
  isRefreshing: boolean
  saveBlockedReason: string | null
  onSave: () => void
  onExport: () => void
}

export function useAgentDetailContext(): AgentDetailContext {
  return useOutletContext<AgentDetailContext>()
}
